/* eslint-disable no-mixed-operators */
import * as React from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import Helper from '../../../core/libraries/Helper';
import { getMySubscriptions, removeSubscription } from '../services';
import Constants from '../../../core/libraries/Constants';
import { RootState } from '../../../store/store';
import { confirmDialog, showToastMessage } from '../../Dialog/actions';
import { IUserProfile } from '../../Auth/types';
import RbLink from '../../../bosch-react/components/link/RbLink';
import RbLoadingSpinner from '../../../bosch-react/components/loading-spinner/RbLoadingSpinner';
import RbLabel, { LabelSize } from '../../../bosch-react/components/label/RbLabel';
import RbTextExpandable from '../../../bosch-react/components/text-expandable/RbTextExpandable';
import RbList, { IRbListItem } from '../../../bosch-react/components/list/RbList';
import _, { forEach } from 'lodash';
import { removeAliasDomain } from '../../../utils/converter';
import { ISubscriptionItem, ISubscriptionState } from '../types';
import { IRefinements } from '../../Search/types';
import { getSearchResultsService } from '../../Search/services';
import { Shimmer, ThemeProvider, mergeStyles } from 'office-ui-fabric-react';
import { getMySubscriptionDispatch } from '../thunks';
import { insertStatisticData, ISearchedStatistic, StatisticType } from '../../Statistics/services';

interface SubscriptionsProps {
    userProfile: IUserProfile | undefined,
    mySubscriptions: ISubscriptionItem[] | undefined,
    confirmDialog: typeof confirmDialog,
    showToastMessage: typeof showToastMessage,
    getMySubscriptionDispatch: any,
}

class Subscriptions extends React.Component<SubscriptionsProps, any> {
    constructor(props: SubscriptionsProps) {
        super(props);

        this.convertData = this.convertData.bind(this);
        this.searchText = this.searchText.bind(this);
        this.openAccessMediator = this.openAccessMediator.bind(this);
        this.getSubscriptions = this.getSubscriptions.bind(this);
        this.removeSubscription = this.removeSubscription.bind(this);
    }

    componentDidMount() {
        let myUserPrincipalName = this.props.userProfile?.loginName
        !!myUserPrincipalName && this.getSubscriptions(removeAliasDomain(myUserPrincipalName));
    }

    async componentDidUpdate(prevProps: Readonly<SubscriptionsProps>, prevState: Readonly<any>, snapshot?: any): Promise<void> {
        let currentProfile = this.props.userProfile
        let prevProfile = prevProps.userProfile
        if (!_.isEqual(currentProfile, prevProfile)) {
            !!currentProfile && this.getSubscriptions(removeAliasDomain(currentProfile.loginName));
        }
        if (!_.isEqual(this.props.mySubscriptions, prevProps.mySubscriptions)) {

        }
    }

    wrapperClass = mergeStyles({
        padding: 2,
        selectors: {
            '& > .ms-Shimmer-container': {
                margin: '10px 0',
            },
        },
    });

    render() {
        let element: any = "";
        if (this.props.mySubscriptions === undefined) {
            element = (
                <div className="ms-Grid">
                    <div className="ms-Grid-col ms-sm12" style={{ textAlign: "center" }}>
                        <RbLoadingSpinner />
                    </div>
                </div>
            );
        }
        else {

            if (this.props.mySubscriptions.length > 0) {
                element = (
                    <div className="ms-Grid subscriptions-grid">
                        <div className="ms-Grid-col ms-sm1 subscriptions-spacer" />
                        <div className="ms-Grid-col ms-sm10 subscriptions-content">
                            <div className="ms-Grid">
                                <div className="ms-Grid-row">
                                    {this.props.mySubscriptions.map((item: ISubscriptionItem) => {
                                        return (
                                            <div className="ms-Grid-col ms-sm4 subscriptions-card" key={item.id}>
                                                <RbTextExpandable title={`${item.title}`} size={LabelSize.Large} isExpanded={true}
                                                    isClosable={true} onClose={() => { this.removeSubscription(item) }}>
                                                        {item.results===undefined?<ThemeProvider className={this.wrapperClass}>
                                                        <Shimmer />
                                                        <Shimmer />
                                                        <Shimmer />
                                                        <Shimmer />
                                                        <Shimmer />
                                                    </ThemeProvider>:item.results.length===0?<RbLabel>No result found</RbLabel>:<RbList items={this.convertData(item.results)} /> }
                                                    <br />
                                                    <RbLink label={"View more"} size={LabelSize.Large} hasIcon={true} onClick={() => { this.searchText(item.title); }} />
                                                </RbTextExpandable>
                                            </div>
                                        )
                                    })}
                                </div>
                            </div>
                        </div>
                        <div className="ms-Grid-col ms-sm1 subscriptions-spacer" />
                    </div>
                );
            }
            else {
                element = (<div className="ms-Grid-col ms-sm12 home-subscriptions-description">
                    <RbLabel>You have not subscribed for any searched keyword. Kindly subscribe to get your favorite search results.</RbLabel>
                </div>);
            }
        }
        return element;
    }

    convertData(data: any[]): IRbListItem[] {
        const result: IRbListItem[] = [];
        data.forEach(item => {
            result.push({
                text: item.Title,
                onClick: () => {
                    this.openAccessMediator(item.Id);
                }
            } as IRbListItem);
        });
        return result;
    }

    async addToSearchedStatistics(searchedText: string) {
        if (!!this.props.userProfile) {
          const { name, department, division } = this.props.userProfile
          let record: ISearchedStatistic = {
            createdBy: name,
            keyword: searchedText,
            department: department || "",
            division: division || "",
          }
          await insertStatisticData(StatisticType.Searched, record)
        }
      }

    searchText(text: any) {
        let searchedText = text.trim() !== "" ? text.trim() : "*";
        this.addToSearchedStatistics(searchedText);
        Helper.openSearchPage(searchedText)
    }

    openAccessMediator(id: any) {
        Helper.openAMPage(id);
    }

    getSubscriptions(yourUserId: string) {
        this.props.getMySubscriptionDispatch(yourUserId)
    }

    removeSubscription(subscriptionObj: ISubscriptionItem) {
        this.props.confirmDialog(
            Constants.CONFIRMATION_MESSAGE.SUBSCRIPTION_REMOVE.TITLE,
            Constants.CONFIRMATION_MESSAGE.SUBSCRIPTION_REMOVE.CONTENT.replace("{0}", subscriptionObj.title),
            false, () => {
                this.setState({ isLoading: true }, async () => {
                    let rs = await removeSubscription(subscriptionObj.id)
                    if (rs === true) {
                        this.props.showToastMessage(
                            Constants.TOAST_MESSAGE_CODE.SUCCESS,
                            Constants.SUBSCRIPTION_MESSAGE.REMOVE.SUCCESS.replace("{0}", subscriptionObj.title)
                        );
                        !!this.props.userProfile?.loginName && this.props.getMySubscriptionDispatch(this.props.userProfile?.loginName)
                    }
                    else {
                        this.props.showToastMessage(
                            Constants.TOAST_MESSAGE_CODE.ERROR,
                            Constants.SUBSCRIPTION_MESSAGE.REMOVE.FAILED.replace("{0}", subscriptionObj.title)
                        );
                    }
                })
            });
    }

}

const mapStateToProps = (state: RootState) => ({
    userProfile: state.auth.userProfile,
    mySubscriptions: state.subscription.subscriptions
});

export default connect(mapStateToProps, { confirmDialog, showToastMessage, getMySubscriptionDispatch })(Subscriptions);